
import { Options, Vue } from "vue-class-component";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import AccountDropdown from "./BaseButtonAccountDropdown/index.vue";
import { usersModule } from "@/store";
import { ClickOutside } from "@/directives";

@Options({
  name: "AccountButton",
  components: {
    SvgIcon,
    AccountDropdown,
  },
  directives: {
    "click-outside": ClickOutside,
  },
})
export default class AccountButton extends Vue {
  protected isDropdownOpen = false;

  protected get isUserAuth(): boolean {
    return usersModule.IsAuthenticated;
  }

  protected toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  protected closeDropdown(): void {
    this.isDropdownOpen = false;
  }
}
